import * as ActionTypes from "../actions/types";

const INITIAL_STATE = {
  name: null,
  params: null,
  parents: null,
};

function updateBreadcrumb(state, action) {
  const { name, params, parents } = action.payload;
  state.name = name;
  state.params = params;
  state.parents = parents;
}

export const breadcrumb = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.UPDATE_BREADCRUMB]: updateBreadcrumb,
  },
};
